import { LogoDefinition } from '../types';

export const brandLogoTransparent: LogoDefinition = {
  id: 'brandLogoTransparent',
  width: 190,
  height: 88,
  svgContent: [
    {
      type: 'path',
      fill: '#f8b400',
      data: 'M79.8031 38.9052C83.9907 38.9052 87.3854 35.5117 87.3854 31.3256C87.3854 27.1396 83.9907 23.7461 79.8031 23.7461C75.6154 23.7461 72.2207 27.1396 72.2207 31.3256C72.2207 35.5117 75.6154 38.9052 79.8031 38.9052Z',
    },
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M36.344 40.6118H22.0078V64.2289H28.7616V45.6816H34.6618C36.0678 45.6816 37.1976 46.811 37.1976 48.2165V64.254H43.9514V48.2165C43.9514 44 40.5368 40.6118 36.344 40.6118Z',
    },
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M110.611 59.1591H106.192C104.887 59.0587 103.857 57.9795 103.857 56.6242V45.6564H110.611V40.5867H103.857V32.1538H97.1034V40.5867H94.1408L90.3496 45.6564H97.1034V56.6493C97.1034 60.8406 100.493 64.2288 104.686 64.2288H110.586V61.4179L110.611 59.1591Z',
    },
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M92.4834 40.6118H84.876L79.8295 47.3631L74.7578 40.6118H67.1504L76.0132 52.4078L67.1504 64.2289H74.7578L79.8295 57.4775L84.876 64.2289H92.4834L83.6206 52.4078L92.4834 40.6118Z',
    },
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M139.283 40.6118L133.382 55.6454L127.482 40.6118H120.729L130.018 64.2289H136.747L146.036 40.6118H139.283Z',
    },
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M119.047 40.6113H112.293V64.2284H119.047V40.6113Z',
    },
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M119.047 32.1787H112.293V38.93H119.047V32.1787Z',
    },
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M57.4348 59.1588C55.3007 59.1588 53.493 57.402 52.7398 54.9424H68.9841C69.1598 54.1393 69.2603 53.2859 69.2603 52.4075C69.2603 45.8821 63.9627 40.5864 57.4348 40.5864C50.907 40.5864 45.6094 45.8821 45.6094 52.4075C45.6094 58.9329 50.907 64.2286 57.4348 64.2286H65.444L69.2351 59.1588H57.4348ZM57.4348 45.6813C59.5689 45.6813 61.3766 47.4381 62.1298 49.8977H52.7398C53.493 47.413 55.3258 45.6813 57.4348 45.6813Z',
    },
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M160.022 40.6118H147.72L145.736 45.6816H158.34C159.746 45.6816 160.876 46.811 160.876 48.2165V49.898H150.758V49.9231C146.992 50.149 144.004 53.2611 144.004 57.076C144.004 60.8909 146.992 64.003 150.758 64.2289V64.254H167.63V48.2165C167.605 44 164.215 40.6118 160.022 40.6118ZM152.44 54.9929C152.565 54.9678 152.691 54.9678 152.791 54.9427H160.876V59.1591H158.039H152.816C152.691 59.1591 152.565 59.134 152.465 59.1089C151.511 58.9081 150.783 58.0548 150.783 57.0509C150.783 56.047 151.461 55.1936 152.44 54.9929Z',
    },
  ],
};
